"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtendedFields = exports.identity = exports.LangUtil = void 0;
var LangUtil = /** @class */ (function () {
    function LangUtil() {
    }
    LangUtil.doIfNotNull = function (obj, action) { if (obj !== undefined && obj !== null)
        action(obj); };
    LangUtil.doIfNotNullOrElse = function (obj, action, elseAction) {
        obj !== undefined && obj !== null ? action(obj) : elseAction();
    };
    LangUtil.doIf = function (condition, action) { if (condition)
        action(); };
    LangUtil.doIfOrElse = function (condition, action, elseAction) { condition ? action() : elseAction(); };
    // TS_SPECIFIC
    LangUtil.EnumValues = function (enumType) {
        return Object.keys(enumType).filter(function (key) { return !isNaN(Number(enumType[key])); });
    };
    LangUtil.prototype.staticEnumsValueOf = function (enumType, value) {
        return enumType[value];
    };
    /**
     * Deep merge two objects.
     * Reference:  https://stackoverflow.com/questions/27936772/how-to-deep-merge-instead-of-shallow-merge
     */
    LangUtil.mergeDeep = function (target) {
        var _a, _b;
        var sources = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            sources[_i - 1] = arguments[_i];
        }
        if (!sources.length)
            return target;
        var source = sources.shift();
        if (LangUtil.isObject(target) && LangUtil.isObject(source)) {
            for (var key in source) {
                if (LangUtil.isObject(source[key])) {
                    if (!target[key])
                        Object.assign(target, (_a = {}, _a[key] = {}, _a));
                    LangUtil.mergeDeep(target[key], source[key]);
                }
                else {
                    Object.assign(target, (_b = {}, _b[key] = source[key], _b));
                }
            }
        }
        return LangUtil.mergeDeep.apply(LangUtil, __spreadArrays([target], sources));
    };
    LangUtil.isObject = function (item) {
        return (item && typeof item === 'object' && !Array.isArray(item));
    };
    LangUtil.isNumber = function (value) {
        return typeof value === 'number' && isFinite(value);
    };
    /**
     * It will do eval first, if it returns function, that's it.
     * otherwise wrap it in `(${args}) => ${script}` or `(${args}) => {${script}}`
     */
    LangUtil.evalAsFunction = function (script, args) {
        var res = LangUtil.tryEval(script);
        if (typeof (res) === 'function')
            return res;
        res = LangUtil.tryEval("(" + args + ") => " + script);
        if (typeof (res) === 'function')
            return res;
        return eval("(" + args + ") => {" + script + "}");
    };
    LangUtil.tryEval = function (script) {
        try {
            return eval(script);
        }
        catch (e) {
            return undefined;
        }
    };
    LangUtil.compare = function (o1, o2) {
        return o1 > o2 ? 1 : (o1 < o2 ? -1 : 0);
    };
    LangUtil.get = function (o, identifier) {
        return typeof (identifier) === 'function' ? identifier(o) : o[identifier];
    };
    // TS_SPECIFIC
    LangUtil.enumValues = function (enumType) {
        return Object.keys(enumType).filter(function (key) { return !isNaN(Number(enumType[key])); });
    };
    LangUtil.enumValueOf = function (enumType, value) {
        return enumType[value];
    };
    return LangUtil;
}());
exports.LangUtil = LangUtil;
var identity = function (o) { return o; };
exports.identity = identity;
var ExtendedFields = /** @class */ (function () {
    function ExtendedFields() {
    }
    return ExtendedFields;
}());
exports.ExtendedFields = ExtendedFields;
//# sourceMappingURL=LangUtil.js.map